// Login Form section - having validation and form fields

import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, CircularProgress, TextField } from "@mui/material";
import * as auth from "../../store/ducks/auth.duck";
import { FormControlLabel } from "@mui/material";
import { Checkbox } from "@mui/material";
import { serverleturl } from "../../router/config";
import axios from "axios";
import { InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Login(props) {
  useEffect(() => {
    const checkboxValue = localStorage.getItem("checkbox") === "true";
    if (checkboxValue && localStorage.userName !== "") {
      setState((prev) => ({
        ...prev,
        isChecked: checkboxValue,
        userName: localStorage.userName || "",
        accountno: localStorage.accountno || "",
        password: localStorage.password || "",
      }));
    }
  }, []);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({ paddingRight: "2.5rem", });
  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };
  const [state, setState] = React.useState({
    accountno: "",
    userName: "",
    password: "",
    isChecked: false,
  });

  const onChangeValue = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const isAuthorized = useSelector((state) => state.auth.authToken === 1);

  useEffect(() => {
    if (isAuthorized) {
      const lastPath = localStorage.getItem("lastPathBeforeLogin") || "/Liveview";
      localStorage.removeItem("lastPathBeforeLogin");
      navigate(lastPath, { replace: true });
    }
  }, [isAuthorized, navigate]);
  const onChangeCheckbox = (event) => {
    setState({ ...state, isChecked: event.target.checked });
  };

  return (
    <>
      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h3 style={{ color: "#25c2a5" }} >
              {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
              <FormattedMessage id="AUTH.LOGIN.TITLE" />
            </h3>
          </div>

          <Formik
            initialValues={{
              accountno: "",
              userName: "",
              password: "",
            }}
            validate={(values) => {
              const errors = {};

              if (!state.accountno) {
                errors.accountno = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD",
                });
              }

              if (!state.userName) {
                // https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
                errors.userName = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD",
                });
              }

              if (!state.password) {
                errors.password = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD",
                });
              }

              return errors;
            }}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              enableLoading();
              if (state.isChecked === true && state.userName !== "") {
                //localStorage.accountno = state.accountno; //commented by karthik on 27/03/2025
                localStorage.userName = state.userName;
                localStorage.password = state.password;
                localStorage.checkbox = state.isChecked;
              } else {

                localStorage.removeItem("userName");
                localStorage.removeItem("password");
                localStorage.removeItem("checkbox");
              }
              //below two lines added by karthika on 27/03/2025 to handle Balmer Lawrie UAE LLC
              if (state && state?.accountno)
                localStorage.setItem("accountno", state.accountno);

              setTimeout(() => {
                // const qs = require("querystring"); //karthika
                const requestBody = {
                  account: state.accountno,
                  userName: state.userName,
                  password: state.password,
                  remember_me: "1",
                };
                const qs = new URLSearchParams(requestBody).toString();
                axios.post(serverleturl + "ReactLoginServlet", qs, {
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                  withCredentials: true, // VERY IMPORTANT
                }).then(function (response) {
                  const res = response.data;

                  if (res === 1) {
                    disableLoading();
                    props.login(res);
                  } else if (res === -1) {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.GENERAL_ERROR",
                      })
                    );
                  } else if (res === -3) {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.SUSBCRIPTION_EXPIRED",
                      })
                    );
                  } else if (res === -5) {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.Suspended",
                      })
                    );
                  } else if (res === -6) {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.ACCESS_RESTRICTED",
                      })
                    );
                  } else {
                    disableLoading();
                    setSubmitting(false);
                  }
                })
                  .catch(() => {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                      intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_LOGIN",
                      })
                    );
                  });
              }, 1000);
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                noValidate={true}
                // autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
              >
                {status ? (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{status}</div>
                  </div>
                ) : (
                  ""
                )}

                {/* <div className="form-group"> */}
                <div className="mb-3">
                  <TextField
                    type="text"
                    label="Account No"
                    margin="normal"
                    className="kt-width-full"
                    name="accountno"
                    onBlur={handleBlur}
                    // onChange={handleChange}
                    onChange={onChangeValue}
                    value={state.accountno}
                    helperText={touched.accountno && errors.accountno}
                    error={Boolean(touched.accountno && errors.accountno)}
                  />
                </div>

                {/* <div className="form-group"> */}
                <div className="mb-3">
                  <TextField
                    type="text"
                    label="User Name"
                    margin="normal"
                    id="email"
                    className="kt-width-full"
                    name="userName"
                    onBlur={handleBlur}
                    // onChange={handleChange}
                    onChange={onChangeValue}
                    value={state.userName}
                    helperText={touched.userName && errors.userName}
                    error={Boolean(touched.userName && errors.userName)}
                  />
                </div>

                {/* <div className="form-group"> */}
                <div className="mb-3">
                  <TextField
                    type={showPassword ? 'text' : 'password'}
                    margin="normal"
                    label="Password"
                    className="kt-width-full"
                    name="password"
                    onBlur={handleBlur}
                    onChange={onChangeValue}
                    value={state.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="login_btn_section">
                  <div>

                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state.isChecked}
                          onChange={onChangeCheckbox}
                        />
                      }
                      id="rememberMe"
                      label="Remember me"
                      style={{ color: "#25c2a5" }}
                      labelPlacement="end"
                    />

                  </div>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting || loading}
                    endIcon={loading && <CircularProgress size={20} color="inherit" />}
                    sx={{
                      minWidth: 120,
                      height: 40,
                      textTransform: 'none',
                      fontWeight: 600,
                      ...(loadingButtonStyle || {})  // Your custom style object
                    }}
                  >
                    {loading ? 'Signing in...' : 'Sign In'}
                  </Button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
}
export default connect(null, auth.actions)(Login);

